jQuery(document).ready(function ($){
    $(".cat").each(function () {
        $(this).on("click", function () {
            if ($(this).hasClass('active')) {
                $('.cat').removeClass('active');
                $('.room').addClass('active');
            } else {
                $('.cat').removeClass('active');
                $(this).addClass('active');
                $('.room').removeClass('active');
                $('.room[data-id*=' + $(this).attr('data-id') + ']').addClass('active');
            }

        });
    });
});